// extracted by mini-css-extract-plugin
export var base = "_4m-0";
export var updateBanner = "_4m-1";